"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freightTrackingEventOrder = exports.FreightTrackingEventType = void 0;
var FreightTrackingEventType;
(function (FreightTrackingEventType) {
    FreightTrackingEventType["CREATED"] = "CREATED";
    FreightTrackingEventType["TENDERED"] = "TENDERED";
    FreightTrackingEventType["ESTIMATED_PICKUP_DATE_CHANGED"] = "ESTIMATED_PICKUP_DATE_CHANGED";
    FreightTrackingEventType["PICKED_UP"] = "PICKED_UP";
    FreightTrackingEventType["LOCATION_UPDATED"] = "LOCATION_UPDATED";
    FreightTrackingEventType["ESTIMATED_DELIVERY_DATE_CHANGED"] = "ESTIMATED_DELIVERY_DATE_CHANGED";
    FreightTrackingEventType["DELIVERED"] = "DELIVERED";
    FreightTrackingEventType["CANCELLED"] = "CANCELLED";
})(FreightTrackingEventType = exports.FreightTrackingEventType || (exports.FreightTrackingEventType = {}));
exports.freightTrackingEventOrder = {
    [FreightTrackingEventType.CREATED]: 1,
    [FreightTrackingEventType.TENDERED]: 2,
    [FreightTrackingEventType.ESTIMATED_PICKUP_DATE_CHANGED]: 3,
    [FreightTrackingEventType.PICKED_UP]: 4,
    [FreightTrackingEventType.LOCATION_UPDATED]: 5,
    [FreightTrackingEventType.ESTIMATED_DELIVERY_DATE_CHANGED]: 5,
    [FreightTrackingEventType.DELIVERED]: 6,
    [FreightTrackingEventType.CANCELLED]: 7,
};
//# sourceMappingURL=FreightTrackingEvent.js.map